import { Component, OnInit ,Inject} from '@angular/core';
import { SettingsService, FacilityService } from 'src/app/services';
import { SettingsMainComponent } from 'src/app/components/settings/settings-main.component';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { IfacilityData } from 'src/app/models/facility/Ifacility';
import {MessageService} from 'src/app/services/'

@Component({
  selector: 'bart-setting-facility-format',
  templateUrl: './setting-facility-format.component.html',
  styleUrls: ['./setting-facility-format.component.scss']
})

export class SettingFacilityFormatComponent implements OnInit {

  acilityFieldFormat: string;
  userId :any =this.parent.userDetail.userId;;
  settingData:any;
  facilityFieldFormat: string;

  constructor(private settingsService: SettingsService, private _messageService:MessageService,
              private facilityService: FacilityService,
              @Inject(SettingsMainComponent) private parent: SettingsMainComponent) { }

  ngOnInit() {  
    this.populateFacilityTab();
   
  }

  setUserSetting(settingObj) {
    var settingData: any;
    var args = {
      "SETUSERSETTING" : {
        settingName: settingObj.settingName,
        userId : this.userId,
        ValueList: settingObj.value
      }     
    }; 
    this.settingsService.setUserSetting( JSON.stringify(args)).subscribe(
      data => 
      {
        //Start:Added By Harikesh on 17-Oct-2020 for defect#12293
        localStorage.removeItem("getUserLocations");
        //end:Added By Harikesh on 17-Oct-2020 for defect#12293
        settingData = data; 
        this._messageService.showAlertMessage("Setting saved successfully");
      },
      err => {
        return console.log(err);
      },
      () => {
        console.log(`Settings saved`);
      }
    ); 
  }

  populateFacilityTab() {

    var args = {
      "GETUSERSETTING":{
      settingName:'facilityFieldFormat',
      UserID: this.userId

      }
    };

    this.settingsService.getUserSetting(JSON.stringify(args)).subscribe(
      data => {

        this.settingData=data;

        if (this.settingData.length> 0) {

          this.facilityFieldFormat= this.settingData[0].value;
        }

      }, 
      err=> {}, 
      () => {}
    );
    
  }

}
